import './cards-animation.js';
import './testimonials-slider.js';
import './text-opacity-animation.js';
import './scroll-animation.js';
import './heading-animation.js';

document.addEventListener('DOMContentLoaded', () => {
    // Set current year for footer copyright
    const currentYearElement = document.getElementById('current-year');
    if (currentYearElement) {
        currentYearElement.textContent = new Date().getFullYear();
    }
});
